import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from '@valhalla/core';
import { IAsmxDto } from '@valhalla/data/entities';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DataHttpCommonService } from '../data-http-common.service';
import { ISimpleSearchCriteria, SearchDataHttpService } from './abstract';

@Injectable()
export class SearchDataHttpServiceImpl implements SearchDataHttpService {
	constructor(readonly http: HttpClient, readonly common: DataHttpCommonService, readonly cookie: CookieService) {}

	simpleSearch<T = any>(criteria: ISimpleSearchCriteria): Observable<T> {
		const payload = Object.assign(this.defaultSipleSearchCriteria(), criteria);
		const url = this.common.getEndpointUrl('/TCWeb.asmx/SimpleSearch');
		return this.http.post<IAsmxDto<T>>(url, payload).pipe(map(r => r?.d));
	}

	protected defaultSipleSearchCriteria(): Partial<ISimpleSearchCriteria> {
		const showClosedTasks = this.cookie.check('SimpleSearch_ShowFinishedTasks');
		const showRejectedTasks = this.cookie.check('SimpleSearch_ShowRejectedTasks');
		return {
			maxResultCount: 2,
			showClosedTasks: showClosedTasks,
			showRejectedTasks: showRejectedTasks,
			searchTypes: [0],
		};
	}
}
